import { setIsOverlayLogin, useAppDispatch } from "@next-platform/client-common-core";

import { SpicyButton } from "@/components/customComponents";

const HERO_SECTION_CONTENT = {
  TITLE: "Unleash Your Creativity: Create Chatbot Characters",
  DESCRIPTION:
    "Create and personalize AI chatbot characters to suit your deepest fantasies, bringing unique, uncensored personalities to life. Sign Up Free to Create Characters.",
  BUTTON_TITLE: "Create Free Account",
};

const CreateCharacterHeroSection = () => {
  const dispatch = useAppDispatch();
  const displayLoginOverlay = () => {
    dispatch(setIsOverlayLogin(true));
  };

  return (
    <div className="bg-[url('/Assets/createBotHeroBG.jpg')] h-[636px] lg:h-[848px] relative bg-cover bg-center flex flex-col justify-end items-center rounded-xl before:content-[''] before:z-10 before:size-full before:absolute before:top-0 before:left-0 before:bg-gradient-to-b before:from-[rgba(255,255,255,0.2)] dark:before:from-[rgba(0,0,0,0.2)] before:via-[rgba(255,255,255,0.2)] dark:before:via-[rgba(0,0,0,0.5)] before:to-[rgba(255,255,255,1)] dark:before:to-[rgba(0,0,0,1)] before:from-0% before:via-50% before:to-100% gap-8 mb-8">
      <h1 className="text-[32px] lg:text-[80px] text-center font-medium max-w-[70%] z-20">{HERO_SECTION_CONTENT.TITLE}</h1>
      <div className="text-[18px] lg:text-[24px] text-center max-w-[80%] z-20">{HERO_SECTION_CONTENT.DESCRIPTION}</div>
      <SpicyButton
        variant="secondary_large"
        color="gradient_primary_alt"
        className="z-20 w-[80%] sm:w-[300px] lg:mx-auto lg:w-auto"
        onClick={displayLoginOverlay}
      >
        {HERO_SECTION_CONTENT.BUTTON_TITLE}
      </SpicyButton>
    </div>
  );
};

export default CreateCharacterHeroSection;
